import httpRequest from './http-request';

class Auth {
  constructor() {
    this.domain = `https://account.wps.cn`;
  }

  // 获取用户登录信息
  async getAuthInfo() {
    const url = `${this.domain}/p/auth/check`;
    return await httpRequest.query({
      url,
      options: { method: 'post', withCredentials: true },
    });
  }

  // 获取用户额外的信息
  async getExtInfo() {
    const url = `${this.domain}/api/v3/mine/props`;
    return await httpRequest.query({
      url,
      options: { methods: 'get', withCredentials: true },
    });
  }

  // 获取用户VIP的信息
  async getVipInfo(userId) {
    const url = `//www.wps.cn/learning/proxy/account/api/users/${userId}`;
    return await httpRequest.query({
      url,
      options: { methods: 'get', withCredentials: true },
    });
  }

  // 退出登录
  async logout() {
    const url = `${this.domain}/p/logout`;
    return await httpRequest.query({
      url,
      options: { method: 'post', withCredentials: true },
    });
  }
}

export default new Auth();
